import { AppProvider, type AppState } from './AppContext.js';
import { ToastProvider } from '../ui/components/Toast.js';
import { Sidebar } from './Sidebar.js';
import { Header } from './Header.js';
import { useHashRoute } from './useHashRoute.js';
import { ROTA_PADRAO, acharRota } from './routes.js';

/**
 * Shell do painel: navegação + header + a tela da rota atual.
 *
 * Recebe o estado já resolvido (dados, papéis, sessão) — a decisão de logar ou
 * não acontece antes, no Gate, para nenhuma tela montar com a permissão errada.
 */
export function App({ state }: { state: AppState }) {
  const [rota, navegar] = useHashRoute(ROTA_PADRAO);
  const atual = acharRota(rota);

  const sair = async () => {
    const url = await state.sair();
    if (url) window.location.assign(url);
    else window.location.reload();
  };

  return (
    <ToastProvider>
      <AppProvider value={state}>
        <div className="app">
          <Sidebar rota={atual.id} onNavigate={navegar} onSair={() => void sair()} />
          <div className="main">
            <Header secao={atual.section} titulo={atual.label} />
            <main className="content">
              <div className="content__inner">{atual.render(navegar)}</div>
            </main>
          </div>
        </div>
      </AppProvider>
    </ToastProvider>
  );
}
